let mainPath = "/specialOrders";
let viewFolder = "SpecialOrder";

module.exports = [
    {
        path: mainPath,
        name: 'Special Orders',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
    },
    {
        path: mainPath+'/view/:id',
        name: 'Special Order',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    },
    {
        path: mainPath+'/create',
        name: 'Create Special Order',
        component: () => import('../views/'+viewFolder+'/Create.vue'),
    },
    {
        path: mainPath+'/bySupplier/:status',
        name: 'By Supplier',
        component: () => import('../views/'+viewFolder+'/BySupplier.vue'),
    }
]